import { Menu } from "antd";
import { useAuth } from "global/context/AuthenticationContext";
import { Route } from "navigation/AppMenu";
import {
  startTransition,
  useCallback,
  useEffect,
  useState,
  useMemo,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

function hasItem(nav: any): nav is { item: Route; children?: Route[] } {
  return nav && typeof nav.item !== "undefined";
}

function SideNavigation({ sideNav, itemsNav, onClick }: any) {
  const { profile } = useAuth();
  const { pathname } = useLocation();

  const navigate = useNavigate();

  const currentKey = pathname.replace("/", "");

  const [openKeys, setOpenKeys] = useState<string[]>([
    currentKey.split("/")[0],
  ]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([currentKey]);

  useEffect(() => {
    if (pathname === "/") {
      navigate("/dashboard");
      return;
    }
    setOpenKeys([currentKey.split("/")[0]]);
    setSelectedKeys([currentKey]);
  }, [pathname, currentKey, profile, navigate]);

  const getItem = useCallback(
    (path: string): Route | undefined => {
      let foundedItem: Route | undefined;

      sideNav.forEach((e: any) => {
        if (hasItem(e)) {
          if (e.item.path.includes(path)) {
            foundedItem = e.item;
          }

          e.children?.forEach((child: any) => {
            if (child.path.includes(path)) {
              foundedItem = child;
            }
          });
        } else {
          if (e.path.includes(path)) {
            foundedItem = e;
          }
        }
      });

      return foundedItem;
    },
    [sideNav],
  );

  const onClickMenuItem = (e: any) => {
    const path = e.key;
    const item = getItem(path);

    const result = onClick?.(item);

    if (result !== false) {
      startTransition(() => {
        navigate(path);
      });
    }
  };

  const onOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  const menuItems = useMemo(
    () =>
      itemsNav.map((item: any) => {
        const hasChildren = !!item.children?.length;

        const label = hasChildren ? (
          <>{item.label}</>
        ) : (
          <Link to={`/${item.key}`}>{item.label}</Link>
        );

        return {
          key: item.key,
          icon: item.icon,
          label,
          children: item.children?.map((child: any) => ({
            key: child.key,
            icon: child.icon,
            label: <Link to={`/${child.key}`}>{child.label}</Link>,
          })),
        };
      }),
    [itemsNav],
  );

  return (
    <div>
      <div className="px-[15px] py-[20px]">
        <img
          src="/mk.png"
          alt="avatar"
          className="w-full h-[90px] object-none"
        />
      </div>

      <Menu
        style={{ background: "transparent" }}
        theme="light"
        mode="inline"
        onClick={onClickMenuItem}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        items={menuItems}
      />
    </div>
  );
}

export default SideNavigation;
